import { Award } from "lucide-react";

/**
 * Tier badge — Bronze / Silver / Gold based on coin balance.
 *   Bronze : < 1,000 coins
 *   Silver : 1,000 – 9,999 coins
 *   Gold   : 10,000+ coins (or verified creator)
 */
export default function TierBadge({ coins = 0, isCreator = false }) {
  let tier = "Bronze";
  let ring = "border-amber-700/60 text-amber-500 bg-amber-950/30";
  if (coins >= 10000 || isCreator) {
    tier = "Gold";
    ring = "border-yellow-400/60 text-yellow-300 bg-yellow-500/10";
  } else if (coins >= 1000) {
    tier = "Silver";
    ring = "border-zinc-400/60 text-zinc-200 bg-zinc-500/10";
  }
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-widest ${ring}`}
      data-testid={`tier-badge-${tier.toLowerCase()}`}
      title={`${tier} tier — based on lifetime gifting activity`}
    >
      <Award size={10} strokeWidth={2.2} /> {tier}
    </span>
  );
}

/** Compact vertical stat block used in the stats row. */
export const Stat = ({ label, value }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-zinc-500">{label}</div>
    <div className="text-sm mt-1 truncate">{value}</div>
  </div>
);

/** Small SVG for the Google logo — inlined so we don't ship an extra asset. */
export const GoogleGlyph = ({ size = 11 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8.1 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 15.2 18.9 12 24 12c3.1 0 5.9 1.2 8.1 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4c-7.7 0-14.3 4.3-17.7 10.7z"/>
    <path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.8-5.3l-6.4-5.4C29.5 34.9 26.9 36 24 36c-5.2 0-9.7-3.3-11.3-8l-6.6 5.1C9.5 39.7 16.2 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.8l6.4 5.4c-.5.5 6.5-4.8 6.5-15.2 0-1.3-.1-2.4-.4-3.5z"/>
  </svg>
);
